/* Tiffany product rail (sections/tc-product-rail.liquid): drives the captured Splide markup through TC.carousel
   (assets/tc-theme.js) and paints the source progress bar from the scroll position. Owner: builder B. */
(function () {
  'use strict';
  if (window.__tcProductRail) return;
  window.__tcProductRail = true;
  function boot() {
    if (!window.TC || !window.TC.init) { window.setTimeout(boot, 50); return; }
    window.TC.init('[data-tc-rail]', function (root) {
      var splide = root.querySelector('.splide');
      if (!splide) return;
      var api = window.TC.carousel(splide, { perMove: 1 });
      if (!api) return;
      var bar = root.querySelector('.progress-bar');
      var track = api.track;
      var list = track.querySelector('.splide__list');
      function paint() {
        var slide = list && list.children[0];
        if (!slide || !bar) return;
        var gap = parseFloat(window.getComputedStyle(list).columnGap) || 0;
        var step = slide.getBoundingClientRect().width + gap;
        if (!step) return;
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        var positions = Math.max(1, Math.round(max / step) + 1);
        var index = Math.min(positions - 1, Math.max(0, Math.round(track.scrollLeft / step)));
        bar.style.width = ((index + 1) / positions * 100) + '%';
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
      window.addEventListener('resize', paint);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(paint);
      paint();
    });
  }
  boot();
})();
